import { Errors } from 'io-ts';
import { failure } from 'io-ts/lib/PathReporter';
import { Either, left, mapLeft } from 'fp-ts/lib/Either';
import { WeatherData } from 'src/state/WeatherData';
import { JsonEncode } from 'src/types/JsonEncode';
import { WeatherDataType } from 'src/types/WeatherDataType';

export function parseWeatherData(html: string): Either<string, WeatherData> {
    // simple document.createElement not acceptable because browser will load resources (images etc)
    // to bypass this behaviour we should create new document that not connected to current one
    const htmlDocument = document.implementation.createHTMLDocument('engadin');
    const div = htmlDocument.createElement('div');
    div.innerHTML = html;

    const component = div.querySelector('[data-component=Weather]');
    if (!component) {
        return left('No valid "Weather" component found');
    }

    const props = component.getAttribute('data-props');
    if (!props) {
        return left('No valid "Data" attribute found');
    }

    return mapLeft<Errors, string>(
        (errors) => `Unexpected weather data: ${failure(errors).join()}`
    )(JsonEncode.pipe(WeatherDataType).decode(props));
}
